import React, { useState, useEffect } from 'react';
import apiClient from '../api';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";

function ProbationForm({ offenses = [], onSubmit, initialData = {}, onCancel }) {
  const [formData, setFormData] = useState({
    offense_id: '',
    probation_officer_id: '',
    conditions: '',
    status: 'Active',
  });
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [staffUsers, setStaffUsers] = useState([]);
  const isEditing = !!initialData.id;

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const res = await apiClient.get('/api/users');
        setStaffUsers(res.data);
      } catch (err) { console.error("Failed to fetch users", err); }
    };
    fetchUsers();
  }, []);

  useEffect(() => {
    if (!isEditing && offenses.length > 0) {
      setFormData(prev => ({ ...prev, offense_id: offenses[0].id }));
    }
    if (isEditing) {
      setStartDate(initialData.start_date ? new Date(initialData.start_date) : null);
      setEndDate(initialData.end_date ? new Date(initialData.end_date) : null);
      setFormData({
        offense_id: initialData.offense_id || '',
        probation_officer_id: initialData.probation_officer_id || '',
        conditions: initialData.conditions || '',
        status: initialData.status || 'Active',
      });
    }
  }, [initialData, isEditing, offenses]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({ ...formData, start_date: startDate, end_date: endDate });
  };

  return (
    <div className="card p-6 mt-4 bg-slate-50 border-gold">
      <h3 className="text-xl font-bold text-slate-800 mb-4">{isEditing ? 'Update' : 'Assign'} Probation</h3>
      <form onSubmit={handleSubmit}>
        <div className="space-y-4">
          {!isEditing && (
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1">For Offense</label>
              <select name="offense_id" value={formData.offense_id} onChange={handleChange} required>
                {offenses.map(o => <option key={o.id} value={o.id}>{o.offense_type} ({o.case_number})</option>)}
              </select>
            </div>
          )}
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">Probation Officer</label>
            <select name="probation_officer_id" value={formData.probation_officer_id} onChange={handleChange} required>
              <option value="">-- Select Officer --</option>
              {staffUsers.map(user => <option key={user.id} value={user.id}>{user.full_name}</option>)}
            </select>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1">Start Date</label>
              <DatePicker selected={startDate} onChange={(date) => setStartDate(date)} className="w-full" dateFormat="dd/MM/yyyy" />
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1">End Date</label>
              <DatePicker selected={endDate} onChange={(date) => setEndDate(date)} className="w-full" dateFormat="dd/MM/yyyy" />
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">Conditions</label>
            <textarea name="conditions" value={formData.conditions} onChange={handleChange} />
          </div>
          {isEditing && (
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1">Status</label>
              <select name="status" value={formData.status} onChange={handleChange}>
                <option value="Active">Active</option>
                <option value="Completed">Completed</option>
                <option value="Violated">Violated</option>
              </select>
            </div>
          )}
        </div>
        <div className="flex justify-end gap-4 pt-4 mt-6 border-t border-slate-200">
          <button type="button" onClick={onCancel} className="bg-slate-200 text-slate-700 hover:bg-slate-300 font-bold py-2 px-4 rounded-lg">Cancel</button>
          <button type="submit" className="bg-gold text-white hover:bg-gold-dark font-bold py-2 px-4 rounded-lg">Save</button>
        </div>
      </form>
    </div>
  );
}

export default ProbationForm;